// extracted by mini-css-extract-plugin
export default {"articleCard":"articleCard_articleCard__7TOKp","author":"articleCard_author__NqGIC"};